import { Injectable } from '@angular/core';
import {  HttpClient } from '@angular/common/http';
import   'rxjs/add/operator/map';
import { SistemaService } from '../services/sistema/sistema.service';
import { Observable } from 'rxjs';
import { Footercontent } from '../models/footer.model';

@Injectable({
  providedIn: 'root'
})
export class ContentPageService {

  url:string = "";
  contentPage:Footercontent;
  logger:boolean = false;

  /**
  * Se encarga de imprimir los logs de el sistema. estos
  * logs se esconden si se esta en modo productivo
  * @param linea [linea de donde se invoca al metodo]
  * @param txt [texto principal del log]
  * @param objeto [objeto que sera impreso, puede ser de cualquier tipo]
  */
  logs(linea:string,txt:string,objeto:any = null):void{
    if (this.logger) {
      if (objeto != null) {
        console.log(linea,txt,objeto);
      }else {
        console.log(linea,txt);
      }
    }
  }

  constructor(private _sistemaService:SistemaService,
              private http:HttpClient) {
    this.url = _sistemaService.url;
    this.logger = _sistemaService.logger;

  }

  /**
  * Realiza una llamada a la api contentpages y retorna la busqueda
  * @param id [string: valor de la busqueda]
  * @return [arreglo retornado por el api]
  */
  getContentPage(id:string):Observable<Footercontent> {
    let headers = new Headers();
    return this.http.get(`${this.url}/contentpages/${id}`).map(this.extractContentPage);
  }

  extractContentPage(res:any) {
    this.contentPage = res;
    return this.contentPage;
  }

}
